<template>
  <div>

    <core-modal-header>Copy Files</core-modal-header>

    <core-modal-body>
      <p>Would you like to copy the Tags from the <strong>selected {{files.length}} file(s)</strong> to your FOREVER Account as well?</p>
    </core-modal-body>

    <core-modal-footer>
      <u-button variant="ghost" color="charcoal" @click="modal.close()">Cancel</u-button>
      <u-button variant="outline" @click="copy()">Files Only</u-button>
      <u-button @click="copy({shouldCopyTags: true})">Files & Tags</u-button>
    </core-modal-footer>

  </div>
</template>

<script setup>
  import {isHttpConflict} from '~/utils/http.js';

  const emit = defineEmits(['success']);
  const props = defineProps({
    files: Array,
    userId: String,
    modal: Object
  });

  async function copy({shouldCopyTags} = {}) {
    try {
      await useFileApi().copyFiles({ids: props.files.map(f => f.id), userId: props.userId, shouldCopyTags});

      useSuccessToast().add({
        id: 'copy-files-success',
        description: `The ${props.files.length} selected file(s) were copied to your FOREVER Account.`
      });

      emit('success');
    } catch (err) {
      if (isHttpConflict(err)) {
        await props.modal.close();
        useCommonModals().openStorageUpsellModal({
          context: STORAGE_UPSELL_CONTEXTS.fileCopyStorageFull
        });
      } else {
        useErrorToast().add();
      }
    }
  }
</script>
